import AxiosApi from './axios.service'
const API_URL = "https://api.fichajedigital.com/api/";
// Función IniciarPausa
export const IniciarPausa = (idUsuario,pin, sede) => {
    return new Promise((resolve, reject) => {
        let data = {
            id_sede: sede,
            pin:pin,
            id_usuario:idUsuario,
        };
        AxiosApi.axiosApi
            .post(API_URL + 'usuarios/iniciarpausapanel', data)
            .then((response) => {
                console.log(response);
                if (response.data) {
                    resolve(response.data);
                } else {
                    reject(new Error('No data in response'));
                }
            })
            .catch((error) => {
                console.log(error.response);
                reject(error);
            });
    });
};

// Función FinalizarPausa
export const FinalizarPausa = (idUsuario,pin, sede) => {
    return new Promise((resolve, reject) => {
        let data = {

            id_sede: sede,
            pin:pin,
            id_usuario:idUsuario,
        };
        AxiosApi.axiosApi
            .post(API_URL + 'usuarios/finalizarpausapanel', data)
            .then((response) => {
                console.log(response);
                if (response.data) {
                    resolve(response.data);
                } else {
                    reject(new Error('No data in response'));
                }
            })
            .catch((error) => {
                console.log(error.response);
                reject(error);
            });
    });
};